import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function StarFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<g clipPath="url(#clip0_5698_98446)">
				<path
					d="M12.0001 1.25C12.3111 1.25 12.5899 1.44201 12.7008 1.73263L15.0588 7.91234L21.5367 8.22913C21.8419 8.24406 22.1075 8.44263 22.2082 8.73111C22.3089 9.0196 22.2245 9.34032 21.9948 9.5419L17.0649 13.8695L18.8768 20.8106C18.9559 21.1135 18.8384 21.4338 18.5822 21.6137C18.3259 21.7937 17.9849 21.7956 17.7267 21.6183L12.0001 17.6875L6.27341 21.6183C6.01525 21.7956 5.67415 21.7937 5.41791 21.6137C5.16166 21.4338 5.04419 21.1135 5.12329 20.8106L6.93523 13.8695L2.00526 9.5419C1.77563 9.34032 1.69124 9.0196 1.79192 8.73111C1.89259 8.44263 2.15821 8.24406 2.4634 8.22913L8.94133 7.91234L11.2993 1.73263C11.4102 1.44201 11.689 1.25 12.0001 1.25Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5698_98446">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

StarFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default StarFilledIcon;
